<script setup lang="ts">
import { inject, ref } from 'vue'
import PageTitle from '@/components/PageTitle.vue'
import { customElementPropsKey } from '@/types/customElementProps.types'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const templateProps = inject(customElementPropsKey)
const formIsValid = ref(false)
const newPassword = ref('')
const confirmPassword = ref('')
const requiredRule = (v: string) => !!v || t('error.field.required')
const passwordMatchRule = (v: string) =>
  v === newPassword.value || t('register.error.password-mismatch')
</script>

<template>
  <div>
    <PageTitle :title="$t('required-action.update-password.card.title')" />

    <v-form
      v-model="formIsValid"
      :action="templateProps?.loginActionUrl"
      method="post"
      novalidate
      class="my-6"
    >
      <input type="hidden" name="username" :value="templateProps?.username" />

      <v-input>
        <v-text-field
          v-model="newPassword"
          type="password"
          autofocus
          name="password-new"
          autocomplete="new-password"
          :label="$t('register.password.label')"
          :rules="[requiredRule]"
        />
      </v-input>

      <v-input>
        <v-text-field
          v-model="confirmPassword"
          type="password"
          name="password-confirm"
          autocomplete="new-password"
          :label="$t('register.password-confirm.label')"
          :rules="[requiredRule, passwordMatchRule]"
        />
      </v-input>

      <ul class="text-body-2 mx-4 mb-6">
        <li>{{ $t('set-password.requirements.label.first') }}</li>
        <li>{{ $t('set-password.requirements.label.second') }}</li>
        <li>{{ $t('set-password.requirements.label.third') }}</li>
      </ul>

      <v-input>
        <v-btn block type="submit" :disabled="!formIsValid">{{
          $t('required-action.update-password.submit.button')
        }}</v-btn>
      </v-input>
    </v-form>
  </div>
</template>
